import React from "react";
import "./A2Why.css";

const A2WhyHead = () => {
  return (
    <div className="a2WhyHeadContainer">
      <h2>
        A2 <span>German Classes</span> in Bangalore at Prizma Academy
      </h2>
      <p>
        At Prizma Academy, we understand that language learning is more than
        just vocabulary and grammar; it's about immersing oneself in the culture
        and context of the language. Our A2 German Classes in Bangalore are
        designed to build on the foundational knowledge acquired in A1, focusing
        on improving conversational skills, comprehension, and cultural
        understanding.
      </p>
    </div>
  );
};

export default A2WhyHead;
